
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/wedding-photography-gear-marketplace",
      function () {
        return require("private-next-pages/lp/wedding-photography-gear-marketplace.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp/wedding-photography-gear-marketplace"])
      });
    }
  